/* Cabinet Giant — promo helper. Reads #cg-promo-data (snippets/promo-data.liquid).
 * 1. Hides every [data-cg-promo] element (and shows every [data-cg-nopromo] element) when the promo
 *    is not running right now in the visitor's browser (covers cached pages served after the end time).
 * 2. Exposes window.CGPromo for the price comparison page and homepage teaser:
 *      CGPromo.isActive()      -> true/false
 *      CGPromo.pctFor(total)   -> percent off for an order subtotal (0 if none)
 *      CGPromo.tiers           -> [{min:2500,pct:25},{min:5000,pct:30}]
 *      CGPromo.endsAt          -> Date or null
 *    and fires a "cg:promo-ready" event on document when it's set up.
 */
(function () {
  var el = document.getElementById('cg-promo-data');
  var data = null;
  try { data = el ? JSON.parse(el.textContent) : null; } catch (e) { data = null; }

  // startsAt / endsAt arrive as Unix seconds (or null)
  function toDate(s) { if (s === null || s === undefined || s === '') return null; var d = new Date(Number(s) * 1000); return isNaN(d) ? null : d; }

  var startsAt = data ? toDate(data.startsAt) : null;
  var endsAt = data ? toDate(data.endsAt) : null;
  var tiers = data && data.tiers ? data.tiers.slice().sort(function (a, b) { return a.min - b.min; }) : [];

  function isActive() {
    if (!data || !tiers.length) return false;
    if (data.isB2B && !data.appliesToWholesale) return false;
    var now = new Date();
    if (startsAt && now < startsAt) return false;
    if (endsAt && now > endsAt) return false;
    return true;
  }

  function pctFor(total) {
    if (!isActive()) return 0;
    var pct = 0;
    for (var i = 0; i < tiers.length; i++) if (total >= tiers[i].min) pct = Math.max(pct, tiers[i].pct);
    return pct;
  }

  function sync() {
    var on = isActive();
    var nodes = document.querySelectorAll('[data-cg-promo]');
    for (var i = 0; i < nodes.length; i++) nodes[i].hidden = !on;
    // Announcement-bar sections can mark their outer wrapper with data-cg-promo-section
    var secs = document.querySelectorAll('[data-cg-promo-section]');
    for (var j = 0; j < secs.length; j++) secs[j].hidden = !on;
    // The "no sale" version of a message (announcement bar, homepage hero) shows only when the sale is off
    var offs = document.querySelectorAll('[data-cg-nopromo]');
    for (var k = 0; k < offs.length; k++) offs[k].hidden = on;
  }

  window.CGPromo = {
    data: data, tiers: tiers, startsAt: startsAt, endsAt: endsAt,
    isActive: isActive, pctFor: pctFor, sync: sync
  };

  sync();
  // Re-check every minute so a page left open past the end time drops the sale.
  setInterval(sync, 60000);
  document.dispatchEvent(new CustomEvent('cg:promo-ready', { detail: window.CGPromo }));
})();
